export default "__VITE_ASSET__7d57cd24__"